/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

